module.exports = __webpack_public_path__ + "img/header-8.57c4654.jpg";